export enum StepControl {
    Create,
    Save,
    Update,
    Validate,
    Cancel,
    Finalize,
}
